<template>
  <radio-group
    v-model="model"
    :class="[
      'text-sm sm:text-base',
      'rounded-md shadow-sm bg-white dark:bg-gray-900 p-1 border border-gray-300 dark:border-gray-800',
      'inline-flex items-stretch shrink-0'
    ]"
    @update:model-value="$emit('input', model)"
  >
    <radio-group-label>
      {{ label }}
    </radio-group-label>

    <radio-group-option
      v-for="[ value, text, disabled, color ] in items"
      :key="text"
      :class="[
        'h-full flex items-center',
        'py-1 px-3 rounded',
        'font-medium text-center whitespace-nowrap cursor-pointer',
        'peer-focus-visible/suggestions:ring peer-focus-visible/suggestions:ring-blue-500 peer-focus-visible/suggestions:border-blue-500',
        optionClass[color || 'orange']
      ]"
      :value="value"
      :disabled="disabled"
    >
      {{ text }}
    </radio-group-option>
  </radio-group>
</template>

<script setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue"
import { computed } from "vue"
import { processItems } from "@/selects"

const model = defineModel([String, Number, Boolean])

const props = defineProps({
  label: { type: String, required: true },
  items: { type: Array, required: true },
})

defineEmits("input")

const items = computed(() => processItems(props.items))

const optionClass = {
  orange: "ui-checked:bg-orange-700/10 ui-checked:text-orange",
  violet: "ui-checked:bg-violet-50 ui-checked:text-violet-700",
}
</script>
